module.exports = __webpack_public_path__ + "img/overview_blaupause_dark.69c4f2e2.gif";